import { FC } from 'react';
import { useField } from 'react-final-form';

import clsx from 'clsx';
import { DeskPlace } from 'src/components/DeskPlace/DeskPlace';
import { useFloorMap } from 'src/components/FloorMap/FloorMapProvider';
import { Desk } from 'src/types';

import { SpaceBookingObjectOption } from '../types';

import classes from './SpaceDeskPlace.module.scss';

export interface SpaceDeskPlaceProps {
  item: Desk;
}

export const SpaceDeskPlace: FC<SpaceDeskPlaceProps> = ({ item }) => {
  const { floor } = useFloorMap();
  const groups =
    useField<Map<number, SpaceBookingObjectOption[]>>('groups').input.value;

  const active = floor?.floorId
    ? !!groups.get(floor.floorId)?.find(d => d.id === item.id)
    : false;

  return (
    <DeskPlace
      item={item}
      figureClassName={classes.figure}
      deskClassName={clsx(classes.desk, active && classes.active)}
      chairClassName={clsx(classes.chair, active && classes.active)}
      titleClassName={clsx(classes.title, active && classes.titleActive)}
    />
  );
};
